'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$ErrorMessage(origin, message) {
  this.WZ = null;
  this.WY = null;
  this.WZ = origin;
  this.WY = message;
}
export { $c_Lpresto_AgentView$ErrorMessage as $c_Lpresto_AgentView$ErrorMessage };
$p = $c_Lpresto_AgentView$ErrorMessage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$ErrorMessage;
/** @constructor */
function $h_Lpresto_AgentView$ErrorMessage() {
}
export { $h_Lpresto_AgentView$ErrorMessage as $h_Lpresto_AgentView$ErrorMessage };
$h_Lpresto_AgentView$ErrorMessage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$ErrorMessage) && ((this.WZ === x$0.WZ) && (this.WY === x$0.WY))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ErrorMessage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.WZ;
  }
  if ((n === 1)) {
    return this.WY;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AgentView$ErrorMessage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hz)));
}
export { $isArrayOf_Lpresto_AgentView$ErrorMessage as $isArrayOf_Lpresto_AgentView$ErrorMessage };
var $d_Lpresto_AgentView$ErrorMessage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$ErrorMessage, "presto.AgentView$ErrorMessage", ({
  hz: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$ErrorMessage as $d_Lpresto_AgentView$ErrorMessage };
//# sourceMappingURL=presto.-Agent-View$-Error-Message.js.map
